@if (videos?.length > 0) {
<div class="bg-primary">
  <div class="container py-3 py-lg-4">
    @if(isTV){
    <h2 class="fw-bold text-white mb-3 mt-0 font-size-18">
      {{ 'tv.title' | translate }}
    </h2>
    }
    <div class="video-gallery">
      <div class="player-container">
        <div class="video-player">
          <fgb-media-player [video]="selectedVideo" />
        </div>
        <div class="video-info">
          <h5 class="video-title">{{ selectedVideo?.Title }}</h5>
          <p class="video-description" [innerHtml]="selectedVideo?.Description | markdownTranslate"></p>
        </div>
      </div>
      <div class="playlist-container">
        <fgb-media-playlist
          [videos]="videos"
          (playlistSelect)="onVideoSelect($event)"
          [selectedIndex]="selectedIndex"
        ></fgb-media-playlist>
      </div>
    </div>
  </div>
</div>
}
